import { useDisclosure } from "@chakra-ui/react";
import Layout from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";
import CreateButton from "components/Shared/CreateButton";
import DirectoryModal from "components/Retailers/Index/DirectoryModal";
import RetailersTableView from "components/Retailers/Index";

export default function RetailersIndex() {
  const {
    isOpen: isRetailerDirectoryModalOpen,
    onClose: handleCloseRetailerDirectoryModal,
    onOpen: handleOpenRetailerDirectoryModal,
  } = useDisclosure();

  return (
    <PageSection
      display="flex"
      flexFlow="column"
      height="100%"
      width="100%"
      padding={0}
    >
      <HeadTitle title="Retailers" />

      <RetailersTableView
        headerRight={
          <CreateButton onClick={handleOpenRetailerDirectoryModal}>
            Add
          </CreateButton>
        }
      />

      <DirectoryModal
        isOpen={isRetailerDirectoryModalOpen}
        onClose={handleCloseRetailerDirectoryModal}
      />
    </PageSection>
  );
}

RetailersIndex.getLayout = (page: React.ReactElement) => (
  <Layout isFullHeight>{page}</Layout>
);
